/* tslint:disable */
/* eslint-disable */
/**
 * Import Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface WorkPublisherPlaceDTO
 */
export interface WorkPublisherPlaceDTO  {
    /**
     * 
     * @type {number}
     * @memberof WorkPublisherPlaceDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkPublisherPlaceDTO
     */
    place?: string;
}

/**
 * Check if a given object implements the WorkPublisherPlaceDTO interface.
 */
export function instanceOfWorkPublisherPlaceDTO(value: object): value is WorkPublisherPlaceDTO {
    return true;
}

export function WorkPublisherPlaceDTOFromJSON(json: any): WorkPublisherPlaceDTO {
    return WorkPublisherPlaceDTOFromJSONTyped(json, false);
}

export function WorkPublisherPlaceDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkPublisherPlaceDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'place': json['place'] == null ? undefined : json['place'],
    };
}

export function WorkPublisherPlaceDTOToJSON(json: any): WorkPublisherPlaceDTO {
    return WorkPublisherPlaceDTOToJSONTyped(json, false);
}

export function WorkPublisherPlaceDTOToJSONTyped(value?: WorkPublisherPlaceDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'place': value['place'],
    };
}


